import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
import classnames from 'classnames/bind';

// Styles
import styles from './jobPlaceholder.module.scss';

const cx = classnames.bind(styles);

const JobPlaceholder = ({ children, className, position }) => (
  <div
    className={cx(
      styles.placeholder,
      `position${startCase(position)}`,
      className,
    )}
  >
    <div className={styles.icon}>
      <span className={cx(styles.iconLineShort, styles.firstLine)} />
      <span className={styles.iconLineLong} />
      <span className={styles.iconLineLong} />
      <span className={cx(styles.iconLineShort, styles.lastLine)} />
    </div>
    <div className={styles.text}>{children}</div>
  </div>
);

JobPlaceholder.defaultProps = {
  className: '',
  position: 'bottom',
};

JobPlaceholder.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  position: PropTypes.oneOf(['bottom', 'top', 'right', 'left']),
};

export default JobPlaceholder;
